import { cloneEntity } from 'services/utils';
import { States } from '../../app.router';
import listComponent from './alerts.component';
import detailComponent from './rules/rules-detail/rules-detail.component'

/**
 * @param $stateProvider
 * @constructor
 * @ngInject
 */
export default function Routes($stateProvider) {
    $stateProvider
        .state(States.ALERTS, {
            url: '/alerts',
            views: {
                'content@main': {
                    component: listComponent.selector
                }
            },
            resolve: {
                activeState: /* @ngInject */ () => {
                    return States.ALERTS;
                }
            }
        })
        .state(States.ALERTS_LOG, {
            url: '/log',
            views: {
                'content@main': {
                    component: listComponent.selector
                }
            },
            resolve: {
                activeState: /* @ngInject */ () => {
                    return States.ALERTS_LOG;
                }
            }
        })
        .state(States.ALERTS_RULES, {
            url: '/rules',
            views: {
                'content@main': {
                    component: listComponent.selector
                }
            },
            resolve: {
                activeState: /* @ngInject */ () => {
                    return States.ALERTS_RULES;
                } 
            }
        })
        .state(States.ALERTS_CONTACTS, {
            url: '/contacts',
            views: {
                'content@main': {
                    component: listComponent.selector
                }
            },
            resolve: {
                activeState: /* @ngInject */ () => {
                    return States.ALERTS_CONTACTS;
                } 
            }
        })
        .state(States.ALERTS_RULES_DETAIL, {
            url: '/{ruleId}',
            params: {
                rule: null
            },
            resolve: {
                activeState: /* @ngInject */ () => {
                    return States.ALERTS_RULES_DETAIL;
                },
                isNew: /* @ngInject */ $stateParams => $stateParams.ruleId === 'new',
                
                rule: /* @ngInject */ (isNew, $stateParams, $q, AlertsAndRulesService, RulesApiService, ProjectManager) => {
                    if (isNew) {
                        return {
                            displayName: '',
                            enabled: true,
                            trigger: null,
                            escalationLevels: [
                                {
                                    displayName: 'Escalation Level 1',
                                    actions: [],
                                    escalateAfter: '7200s'
                                }
                            ],
                        };
                    }
                    if ($stateParams.rule?.id === $stateParams.ruleId) {

                        // Check if the rule is an organization template
                        if ($stateParams.rule.name && $stateParams.rule.name.startsWith('organizations/')) {
                            const clonedRule = cloneEntity($stateParams.rule);
                            clonedRule.isOrganizationTemplate = true;
                            return clonedRule;
                        }

                        // Check if the rule is from the correct project
                        const ruleProjectId = $stateParams.rule.name.split('/')[1];
                        if (ruleProjectId !== $stateParams.projectId) {
                            return null
                        }
                        
                        return cloneEntity($stateParams.rule);
                    }
                    return $q((resolve) => {
                        // First try to get it as a regular project rule
                        AlertsAndRulesService.getRule($stateParams.ruleId).then(
                            (rule) => resolve(rule)
                        ).catch(() => {
                            // If that fails, try to get it as an organization template
                            const organizationId = ProjectManager.currentProject.organizationId;
                            if (organizationId) {
                                RulesApiService.getOrganizationRule(organizationId, $stateParams.ruleId).then(
                                    (orgRule) => {
                                        orgRule.isOrganizationTemplate = true;
                                        resolve(orgRule);
                                    }
                                ).catch(() => resolve());
                            } else {
                                resolve();
                            }
                        });
                    });
                }
            },
            onEnter: /* @ngInject */ (rule, $state, $stateParams) => { // eslint-disable-line consistent-return
                if (!rule) {
                    return $state.target(States.ALERTS_RULES, {
                        projectId: $stateParams.projectId
                    });
                }
            },
            component: detailComponent.selector
        });
}
